import { ReactGoogleReviews } from "react-google-reviews";
import { motion, Variants, Easing } from "framer-motion";
import "react-google-reviews/dist/index.css";
import "./style.scss";

const itemVariants: Variants = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.8, ease: "easeOut" as Easing },
  },
};

const GoogleReviewsCarousel: React.FC = () => {
  // Displaying the carousel of reviews
  const widgetId = process.env.REACT_APP_GOOGLE_REVIEWS_WIDGET_ID || "";
  return (
    <motion.div
      className="google-reviews-carousel-wrapper"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={itemVariants}
    >
      <ReactGoogleReviews
        featurableId={widgetId}
        layout="carousel"
        maxCharacters={160}
      />
    </motion.div>
  );
};

export default GoogleReviewsCarousel;
